//export const APIbase = "https://xlxvalv1p.dc.ht.hr/ValSrvAPI"
//export const APIbase = "http://localhost:9560"
export const APIbase = "https://nadzor.kron.hr/DevelopmentSrvImenik"